module.exports = __webpack_public_path__ + "img/bg_avatar_male_81.c3d9885f.png";